
import { Button } from '@/components/ui/button';
import { Building, Droplets, Box, FileText } from 'lucide-react';

interface EmptyPortfolioStateProps {
  onCreateClick: () => void;
}

export const EmptyPortfolioState = ({ onCreateClick }: EmptyPortfolioStateProps) => {
  return (
    <div className="flex flex-col items-center justify-center py-12 px-4">
      <div className="bg-blue-50 p-6 rounded-full mb-6">
        <div className="flex space-x-2">
          <Building className="h-8 w-8 text-blue-600" />
          <Droplets className="h-8 w-8 text-green-600" />
          <Box className="h-8 w-8 text-amber-600" />
          <FileText className="h-8 w-8 text-purple-600" />
        </div>
      </div>
      
      <h2 className="text-2xl font-bold mb-3 text-center">Create Your First Portfolio</h2>
      
      <p className="text-muted-foreground text-center max-w-lg mb-6">
        Portfolios help you organize your products for certification. Group similar items together and track their certification progress in one place.
      </p>
      
      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 w-full max-w-4xl mb-8">
        {[
          { 
            title: 'Buildings', 
            icon: <Building className="h-6 w-6" />, 
            description: 'For buildings and construction projects seeking sustainability certification' 
          },
          { 
            title: 'Formulated Products', 
            icon: <Droplets className="h-6 w-6" />, 
            description: 'Chemical products, cleaning agents, and other formulations' 
          },
          { 
            title: 'Interior Spaces', 
            icon: <Box className="h-6 w-6" />, 
            description: 'Interior design and furniture collections for sustainable spaces' 
          },
          { 
            title: 'Paper Rolls', 
            icon: <FileText className="h-6 w-6" />, 
            description: 'Paper products seeking environmental certification' 
          }
        ].map((item, i) => (
          <div key={i} className="bg-background p-4 rounded-lg border">
            <div className="h-10 w-10 bg-primary/10 flex items-center justify-center rounded-full mb-3">
              {item.icon}
            </div>
            <h3 className="font-medium mb-2">{item.title}</h3>
            <p className="text-sm text-muted-foreground">{item.description}</p>
          </div>
        ))}
      </div>
      
      <Button size="lg" onClick={onCreateClick}>
        Create Your First Portfolio
      </Button>
    </div>
  );
};
